import React from 'react';

const ActionCard = ({ title, description, href, icon }) => (
  <a
    href={href}
    className="block bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
  >
    <div className="flex items-center mb-4">
      <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mr-4">
        <span className="text-2xl text-orange-500">{icon}</span>
      </div>
      <h3 className="text-xl font-semibold text-gray-900">{title}</h3>
    </div>
    <p className="text-gray-600">{description}</p>
  </a>
);

const AdminDashboard = () => {
  const actions = [
    {
      title: 'Editar Categorias',
      description: 'Gerencie as categorias principais de produtos',
      href: '/admin/categories',
      icon: '📝'
    },
    {
      title: 'Gerenciar Subcategorias',
      description: 'Visualize, edite e gerencie a estrutura hierárquica completa',
      href: '/admin/subcategories',
      icon: '🌲'
    },
    {
      title: 'Gerenciar Produtos',
      description: 'Crie, edite e exclua modelos de produtos',
      href: '/admin/product_models',
      icon: '🛠️'
    },
    {
      title: 'Taxas e Impostos',
      description: 'Configure taxas de importação e impostos por categoria',
      href: '/admin/tax_values',
      icon: '💹'
    },
    {
      title: 'Orçamentos',
      description: 'Visualize os orçamentos gerados pelos clientes',
      href: '/admin/quotes',
      icon: '💰'
    },
    {
      title: 'Gerenciar Database',
      description: 'Exportar e importar backup completo do banco de dados',
      href: '/admin/database',
      icon: '💾'
    },
    {
      title: 'Exportar Excel',
      description: 'Exportar dados para planilhas Excel para análise e relatórios',
      href: '/admin/exports',
      icon: '📊'
    },
    {
      title: 'Templates de Produtos',
      description: 'Personalizar campos de especificação para diferentes categorias',
      href: '/admin/product_templates',
      icon: '🎨'
    },
    {
      title: 'Importar Excel',
      description: 'Importar produtos em massa através de arquivos Excel',
      href: '/admin/imports',
      icon: '📤'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Painel Administrativo</h1>
          <p className="text-gray-600">
            Gerencie categorias, produtos e configurações do sistema
          </p>
        </div>

        {/* Actions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {actions.map((action, index) => (
            <ActionCard key={index} {...action} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard; 